export const baseURL = process.env.NODE_ENV === 'development'
    ? 'http://192.168.144.106'
    : `${window.location.protocol}//${window.location.hostname}`;
